export default __webpack_public_path__ + "static/media/sunlife.19d199c7.jpg";